import React from 'react';
import ReactDom from 'react-dom';
import * as html from '../util/html';
require('./field.scss');

class Field extends React.Component {
    constructor(props) {
        super(props);
        this.isSearchForm = this.props.formType === 'searchForm' ? true : false;
        this.cmp_relativeData = this.props.cmp_relativeData;
        this.validators = this.props.children.props.validators;
    }

    componentDidUpdate() {
        if(!this.props.errorScrollInToView) {
            return null;
        }
        let formError = this.props.errorScrollInToView();
        let errorDom = ReactDom.findDOMNode(this.refs['field']);
        let node = document.getElementsByClassName('ui-page-content');

        if(formError && Object.keys(formError).length > 0 && (this.props.field_name == Object.keys(formError)[0])) {
            errorDom.scrollIntoView();
            for (let i = 0; i < node.length; i++) {
                if(node[i].className == 'ui-page-content') {
                    node[i].scrollTop = node[i].scrollTop - 120;
                }
            }
        }
    }

    handleChange(value) {
        if(this.props.onChange) {
            Object.assign(value,{ name: this.props.children.props.field_name });
            this.props.onChange(value, this.cmp_relativeData, this.isSearchForm ? null : this.validators, this.props.children.props.cmp_type);
        }
    }

    handleBlur(value, valideData) {
        if(!value) {
            return null;
        }
        let validators = valideData ? Object.assign(this.validators, valideData) : this.validators;
        if(this.props.onBlur) {
            Object.assign(value,{ name: this.props.children.props.field_name });
            this.props.onBlur(value, this.cmp_relativeData, this.isSearchForm ? null : validators, this.props.children.props.cmp_type);
        }
    }

    handleFocus(e) {
        this.props.onFocus && this.props.onFocus(e);
    }

    render() {
        return (<div className='form-field'>
            {React.cloneElement(this.props.children,
            { onChange: this.handleChange.bind(this)
                ,onBlur: this.handleBlur.bind(this)
                ,onFocus: this.handleFocus.bind(this)
                ,ref: 'field'
            })}
        {this.props.promptmessage ? <span className='promptmessage'>{html.decode(this.props.promptmessage)}</span> : null}
        </div>);
    }
}

export default Field;



// WEBPACK FOOTER //
// ./src/components/Form/Field.js